import React from 'react';
import { decodeHTMLEntities } from 'src/utils/html.utils';
import { StyledTitle } from './entity-layout.styles';
import { IEntityLayoutTitle } from './entity-layout.types';

export const EntityLayoutTitle = ({ title }: IEntityLayoutTitle) => (
    <StyledTitle variant="text" size="lg" tag="div" semiBold center>
        {decodeHTMLEntities(title)}
    </StyledTitle>
);
